<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <v-toolbar
                    id="member-code-toolbar"
                    flat
                >
                    <v-row>
                        <v-col
                            cols="6"
                        >
                            <v-toolbar-title>
                                Member Code
                            </v-toolbar-title>
                        </v-col>
                        <v-col
                            cols="6"
                            class="text-right"
                        >
                            <AddMemberCode
                                model-type="Add"
                            />
                        </v-col>
                    </v-row>
                </v-toolbar>
            </v-col>
        </v-row>
        <v-row
            class="mt-0"
            :no-gutters="this.$vuetify.breakpoint.xs"
        >
            <v-col>
                <v-data-table
                    id="member-code-table"
                    :headers="computedHeaders"
                    :items="companyMemberCodes"
                    class="elevation-1 mx-2"
                    fixed-header
                    item-key="layer_id"
                    dense
                >                   
                    <template v-slot:[`item.edit`]="{item}">
                        <AddMemberCode
                            :member-details="item"
                            model-type="Edit"
                        />
                    </template>
                    <template v-slot:[`item.delete`]="{item}">
                        <DeleteMemberCode
                            model-type="DeleteIcon"
                            :member-code="item"
                        />
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import AddMemberCode from './AddMemberCode';
import DeleteMemberCode from './DeleteMemberCode';
import { hasPermission } from '../../../utils/permissions';
export default {
    name: 'MemberCodeList',
    components: {
        AddMemberCode,
        DeleteMemberCode
    },
    data: () => ({
        headers: [
            {
                text: 'Center',
                align: 'left',
                sortable: false,
                value: 'center_abbrev',
            },
            {
                text: 'Member Code',
                align: 'left',
                sortable: false,
                value: 'member_code',
            },
            {
                text: 'Description',
                align: 'left',
                sortable: false,
                value: 'description',
            },
            {
                text: 'Screen Destination',
                align: 'left',
                sortable: false,
                value: 'screen_destination',
            },
            {
                text: 'Screen Delivery Format',
                align: 'left',
                sortable: false,
                value: 'screen_delivery_format',
            },
            {
                text: 'Facility Types',
                align: 'left',
                sortable: false,
                value: 'facility_type',
            },
            {
                text: '+R/Center',
                align: 'center',
                sortable: false,
                value: 'sendPrCenter',
            },
            {
                text: '+R/Excavator',
                align: 'left',
                sortable: false,
                value: 'sendPrExcavator',
            },
            {
                text: 'Edit',
                align: 'center',
                value: 'edit',
                sortable: false,
            },
            {
                text: 'Delete',
                align: 'center',
                value: 'delete',
                sortable: false,
            }
        ],
    }),
    computed: {
        companyMemberCodes() {
            let companyMemberCodes = [...this.$store.getters.companyMemberCodes];
            companyMemberCodes = companyMemberCodes.map(item => {
                item.sendPrCenter = item.send_pr_center ? 'YES' : 'No';
                item.sendPrExcavator = item.send_pr_excavator ? 'YES' : 'No';
                return item;
            });
            return companyMemberCodes;
        },
        computedHeaders() { 
            if (hasPermission('USE_SCREEN_LOGIX')) {
                return this.headers;
            }
            return this.headers.filter(header => header.value !== 'screen_destination' && header.value !== 'screen_delivery_format');
        },
    },
    methods: {
        getCompanyOptions() {
            return this.$store.getters.companyOptions;
        },          
    },
};

</script>

<style>
    #member-code-table .v-data-table-header tr th {
        background-color: #F5F7FA;
        white-space: nowrap;
    }
    #member-code-table td {
        white-space: nowrap;
    }
</style>

